<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
      <div class="col-10 h5 text-muted p-0">Coupon Products</div>
      <div class="col-2 p-0">
        <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back" (click)="onBackClick()">
          <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>
  
    <div class="row bg-light">
      <div class="col-12 p-2">
  
        <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="couponsLoading === true">
          <div class="col-12">
            <div class="spinner-border text-info  mt-4" role="status"></div>
          </div>
        </div>
  
        <div class="row mt-2 pb-4">
          <div class="col-12">

            <div class="row text-center mt-4 mb-4" *ngIf="couponsLoading == false && coupons.length == 0">
              <i-bs class="text-black-50 mt-4 pt-4" name="tags" width="30" height="30"></i-bs>
              <div class="col-12 mb-4 pb-4 text-black-50">Coupons not found</div>
            </div>

            <div class="row" *ngIf="couponsLoading == false && coupons.length > 0">
              <div class="col-12">
                <button type="button" class="btn btn-secondary btn-sm text-white float-start fw-bold mb-2" title="Export Coupon Products" (click)="generateCSVFile()">
                  <i-bs class="text-light" name="filetypeCsv" width="20" height="20"></i-bs>&nbsp;&nbsp;Export Coupon Products
                </button>
              </div>
            </div>
            
            <!-- Coupons -->
            <div class="row" *ngIf="couponsLoading === false && coupons.length > 0">
              <div class="col-12 mb-3">
                <accordion [isAnimated]="true" [closeOthers]="true">
                    <accordion-group panelClass="custom-accordion-group bg-light" *ngFor="let coupon of coupons">
                        <button class="btn btn-block justify-content-between d-flex w-100 shadow-none p-0" accordion-heading type="button">
                            <div class="header fw-normal pull-left float-left">{{ coupon.coupon_title }}</div>
                            <span class="badge badge-info rounded-pill bg-info fw-normal float-right pull-right">{{ coupon.products.length }} Product<span *ngIf="coupon.products.length > 1">s</span></span>
                        </button>
                       <p class="content text-dark" *ngFor="let product of coupon.products">
                        {{ product.item_name }} ({{ product.upc }})
                       </p>
                    </accordion-group>
                 </accordion>
              </div>
            </div>
        
          </div>
        </div>
  
      </div>
    </div>
  </div>
  

